/*
 * Copyright (c) 2026. BrightNight. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */

import type { DeepKeys } from '@tanstack/react-form';
import type { FormApi } from './form';

type FormValidationMetaApi<TValues extends object> = Pick<
  FormApi<TValues>,
  'setFieldMeta' | 'state'
>;

export const clearFormValidationMeta = <TValues extends object>(
  form: FormValidationMetaApi<TValues>,
) => {
  for (const field of Object.keys(form.state.fieldMeta) as Array<DeepKeys<TValues>>) {
    form.setFieldMeta(field, (prev) => ({
      ...prev,
      errorMap: {},
      errorSourceMap: {},
    }));
  }
};
